// extracted by mini-css-extract-plugin
export var activityContainer = "_nc-0";
export var typingIndicatorContainer = "_nc-1";
export var typingIndicatorDot = "_nc-2";
export var wave = "_nc-3";